<template>
  <div class="doctor_wrap" :class="{ modal_doctor: props.mode }">
    <a-spin :spinning="loading">
      <div class="searchContainer" ref="searchRef">
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.doctorId"
            size="large"
            placeholder="医生ID"
            allowClear
            @input="inputFormat($event, 'doctorId', 3)"
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.doctorName"
            size="large"
            placeholder="医生姓名"
            allowClear
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item" v-if="mode !== 'bd'">
          <a-select
            style="width: 200px"
            placeholder="选择职业"
            size="large"
            :options="careerTypeList"
            v-model:value="listQuery.careerType"
          />
        </div>
        <div class="search-item" v-if="mode !== 'bd'">
          <a-tree-select
            class="search-input"
            allowClear
            size="large"
            style="width: 200px"
            v-model:value="listQuery.deptId"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="departmentTreeData"
            :replaceFields="{ children: 'childs', title: 'name', key: 'id', value: 'id' }"
            placeholder="科室"
          />
        </div>
        <div class="search-item" v-if="mode !== 'bd'">
          <a-tree-select
            allowClear
            size="large"
            style="width: 200px"
            v-model:value="listQuery.cityId"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="cityTreeData"
            placeholder="地区"
            :replaceFields="{ children: 'childs', title: 'label', key: 'value', value: 'value' }"
          />
        </div>
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.phone"
            size="large"
            @input="inputFormat($event, 'phone', 3)"
            placeholder="医生手机号"
            allowClear
            :maxLength="11"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="dateList"
            :placeholder="['注册开始日期', '注册结束日期']"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
          />
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.status"
            style="width: 200px"
            :options="anthStatusMap"
            placeholder="认证状态"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.recordStatus"
            style="width: 200px"
            :options="recordStatusMap"
            placeholder="备案状态"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.isCancel"
            style="width: 200px"
            :options="logOffStatusMap"
            placeholder="注销状态"
            allowClear
          ></a-select>
        </div>

        <div class="search-item">
          <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="doSearch">
            搜索
          </a-button>
        </div>
      </div>
      <div class="data_wrap">
        <slot name="title"><div class="title">全部医生</div></slot>
        <a-table
          class="table"
          :pagination="pagination"
          :rowKey="(record, index) => index"
          :columns="columns"
          :data-source="tableData"
          @change="onChangePage"
          :scroll="{ x: `calc(100% - 40px)`, y: `calc(100vh - ${sHeight}px )` }"
          :transformCellText="({ text }) => text ?? '--'"
        >
          <template #doctorPhone="{ record }">
            <!-- 医生电话号码 -->
            <span v-if="record.doctorPhone">
              {{ record.doctorPhone }}
              <auth-img :src="see_detail" class="see_detail" @click="seeInfo(record.doctorId, 2)" />
            </span>
            <span v-else>--</span>
          </template>
          <template #bdPhone="{ record }">
            <!-- BD手机号码 -->
            <span v-if="record.bdPhone">
              {{ record.bdPhone }}
              <auth-img :src="see_detail" class="see_detail" @click="seeInfo(record.bdId, 3)" />
            </span>
            <span v-else>--</span>
          </template>
          <template #statusStr="{ record }">
            <!-- 认证状态 -->
            <the-tag v-if="record.statusStr" :color="anthStatusMap[record.status].color">
              {{ record.statusStr }}
            </the-tag>
            <span v-else>--</span>
          </template>
          <template #recordStatusStr="{ record }">
            <!-- 备案状态 -->
            <the-tag
              v-if="record.recordStatusStr"
              :color="recordStatusMap[record.recordStatus].color"
            >
              {{ record.recordStatusStr }}
            </the-tag>
            <span v-else>--</span>
          </template>
          <template #isCancelStr="{ record }">
            <!-- 关注状态 -->
            <the-status v-if="record.isCancelStr" :color="logOffStatusMap[record.isCancel].color">
              {{ record.isCancelStr }}
            </the-status>
            <span v-else>--</span>
          </template>
          <template #boundPatientNum="{ record }">
            <!-- 绑定患者人数 -->
            <span class="link_content" @click="doctBindPatients(record)">
              {{ record.boundPatientNum }}
            </span>
          </template>
          <template #handle="{ record }">
            <!-- <a-space> -->
            <a-button type="link" @click="selEvaluation(record)" v-if="record.evaluationSwitch">
              查看评价
            </a-button>
            <RemarkPopover
              :key="record.doctorId"
              mode="doctor"
              :allowClear="true"
              :remarkData="record?.doctorRemarkVO ?? {}"
              :initParam="record"
              @updateRemark="searchList"
            >
              <template #content>
                <a-button type="link" class="clear">
                  {{ record.remarkSwitch ? '查看备注' : '协同备注' }}
                </a-button>
              </template>
            </RemarkPopover>
            <a-button class="button" type="link" @click="onSendSMS(record)">发送短信</a-button>
            <!-- </a-space> -->
          </template>
        </a-table>
      </div>
    </a-spin>
    <Details ref="detailsRef" />
    <UserInfo ref="userInfoRef" />
    <Evaluation ref="evaluationRef"></Evaluation>
    <SendSMS ref="sms"></SendSMS>
  </div>
</template>
<script>
export default { name: 'doctor' }
</script>
<script setup>
import { reactive, ref, onMounted, nextTick, defineProps, watch, defineEmits, computed } from 'vue'
import Details from '@/views/UserPool/components/Details'
import Evaluation from '@/views/UserPool/components/Evaluation'
import {
  paginationConfig,
  initColumns,
  recordStatusMap,
  logOffStatusMap,
  anthStatusMap
} from './config'
import { inputRule } from '@/utils/validate'
import { formatDateForFilter } from '@/utils'
import { getCityList, getDoctorList } from '@/api/UserPool'
import UserInfo from '@/views/UserPool/components/UserInfo'
import moment from 'moment'
import see_detail from '@/assets/img/see_detail.png'
import RemarkPopover from '@/components/RemarkPopover'
import SendSMS from '@/components/SendSMS/index.vue'
import { SearchOutlined } from '@ant-design/icons-vue'
import { getCareerTypeList, getDepartmentByCareer } from '@/api/chat'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'

const emits = defineEmits(['doctBindPatients'])
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  },
  mode: {
    type: String,
    default: ''
  },
  // 20260-1-9 领导说页面进来的时候不要查询
  // 是否立即发起请求
  immediately: {
    type: Boolean,
    default: false
  }
})
const searchRef = ref(null)
const detailsRef = ref(null)
const userInfoRef = ref(null)
const evaluationRef = ref(null)
const initDateList = []
const dateList = ref([...initDateList])
const loading = ref(false)
const defaultQuery = {
  doctorId: null, //医生id
  doctorName: '', // 医生姓名
  careerType: 1, //职业
  endTime: null, //注册结束时间
  isCancel: null, //注销状态
  recordStatus: null, //平台状态
  startTime: null, //注册开始时间
  status: null, //认证状态
  deptId: null, //科室
  cityId: null, // 地区
  phone: null // 医生手机号
}
const listQuery = reactive({ ...defaultQuery })
const pagination = reactive({ ...paginationConfig })
const tableData = ref([])
const store = useStore()
const cacheEnabled = computed(() => !props.mode)
const defaultCacheQuery = {
  ...defaultQuery,
  dateList: [...initDateList],
  current: paginationConfig.current,
  pageSize: paginationConfig.pageSize
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.DOCTOR_POOL_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    dateList: Array.isArray(params?.dateList) ? params.dateList : [...initDateList]
  })
})

const applyCacheQuery = cacheQuery => {
  if (!cacheEnabled.value) return
  Object.assign(listQuery, defaultQuery, cacheQuery)
  dateList.value = cacheQuery.dateList || [...initDateList]
  pagination.current = cacheQuery.current || paginationConfig.current
  pagination.pageSize = cacheQuery.pageSize || paginationConfig.pageSize
}

const persistCache = () => {
  if (!cacheEnabled.value) return
  updateCache({
    ...listQuery,
    dateList: dateList.value,
    current: pagination.current,
    pageSize: pagination.pageSize
  })
}

const sHeight = ref(112)
const departmentTreeData = ref([])
const cityTreeData = ref([])
const careerTypeList = ref([])
const columns = ref(initColumns)

const handleParams = (val = {}) => {
  columns.value = initColumns
  if (props.mode === 'patient') {
    listQuery.patientId = val.patientId
    listQuery.bdId = null
    dateList.value = []
  }
  if (props.mode === 'bd') {
    listQuery.bdId = val.hid
    listQuery.patientId = null
    const list = ['agencyName', 'bdName', 'bdPhone', 'handle']
    const newColumns = initColumns.filter(it => !list.includes(it.dataIndex))
    columns.value = newColumns
    dateList.value = []
  }
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  searchList()
}
watch(
  () => props.params,
  val => {
    if (val === undefined) return
    handleParams(val)
  },
  {
    immediate: true,
    deep: true
  }
)
// 获取科室列表
const getDepartmentListFn = async careerType => {
  try {
    const res = await getDepartmentByCareer({ careerType })
    departmentTreeData.value = res || []
  } catch (error) {
    departmentTreeData.value = []
  }
}
// 获取职业类型列表
const getCareerList = async () => {
  try {
    const res = await getCareerTypeList()
    careerTypeList.value = res?.map(item => ({ label: item.value, value: item.code })) || []
  } catch (error) {
    console.log(error)
    careerTypeList.value = []
  }
}
watch(
  () => listQuery.careerType,
  val => {
    listQuery.deptId = null
    getDepartmentListFn(val)
  },
  { immediate: true }
)
const selEvaluation = row => {
  console.log('查看评价', row)
  evaluationRef?.value.openList(row)
}
function resetQuery() {
  Object.assign(listQuery, defaultQuery)
  dateList.value = initDateList
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  if (props.mode) {
    dateList.value = []
  }
  persistCache()
  searchList()
}
function doSearch() {
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  // persistCache()
  searchList()
}
function searchList() {
  loading.value = true
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  const params = {
    ...listQuery,
    pageNo: pagination.current,
    pageSize: pagination.pageSize,
    startTime,
    endTime
  }
  getDoctorList(params)
    .then(res => {
      const { list = [], totalCount } = res
      tableData.value = list
      pagination.total = totalCount
      pagination.showTotal = () => `共${totalCount}条`
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}
const disabledDate = current => {
  // Can not select days before today and today
  return !(current && current < moment().endOf('day'))
}
function inputFormat(e, key, type) {
  listQuery[key] = inputRule(e.target.value, type)
}
const onChangePage = (page, filters, sorter) => {
  pagination.current = page.current
  pagination.pageSize = page.pageSize
  listQuery.sortField = sorter.order ? sorter.field : null
  listQuery.sortOrder = sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : null
  persistCache()
  searchList()
}
const getCityListFn = () => {
  getCityList()
    .then(res => {
      // 转换数据结构，将 label 替换为 title
      const transformData = data => {
        if (!data) return null
        return {
          ...data,
          title: data.title,
          children: data.children ? data.children.map(transformData) : []
        }
      }
      cityTreeData.value = res ? res.map(transformData) : []
    })
    .catch(() => {
      cityTreeData.value = []
    })
}
const getHeight = () => {
  nextTick(() => {
    sHeight.value = (searchRef?.value?.clientHeight || 112) + 300
  })
}

const seeInfo = (id, type) => {
  const params = {
    accountType: type,
    id
  }
  userInfoRef?.value.initModal(params)
}
// 查看医生绑定的患者人数
const doctBindPatients = row => {
  const { boundPatientNum } = row
  if (!boundPatientNum) return
  if (props.mode) {
    emits('doctBindPatients', row)
  } else {
    row.mode = 'doctor'
    detailsRef?.value?.initModal(row)
  }
}
const sms = ref()
function onSendSMS(record) {
  // console.log(record)
  const { ucPatientId = null, ucDoctorId = null } = record
  const pInfo = {
    id: ucPatientId
  }
  const dInfo = {
    id: ucDoctorId,
    name: record.doctorName
  }
  sms.value.open(2, pInfo, dInfo)
}
onMounted(() => {
  getCityListFn()
  getCareerList()
  getHeight()
  // applyCacheQuery(initFromCache())
  // props.immediately && searchList()
})
</script>
<style scoped lang="scss">
.doctor_wrap {
  height: 100%;
  &.modal_doctor {
    .searchContainer {
      padding: initial;
      margin-bottom: 14px;
    }
    .data_wrap {
      margin: initial;
      padding: initial;
    }
  }
}
.searchContainer {
  background-color: #fff;
  padding: 10px 20px 0;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search_icon {
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
.data_wrap {
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  .title {
    font-weight: 400;
    font-size: 14px;
    color: #000000e0;
    margin-bottom: 17px;
  }
  .see_detail {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    cursor: pointer;
  }
}
</style>
